import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();

  const guideLang = lang === "fr" ? "fr" : "nl";
  const guides = [
    { label: { nl: "Phishing herkennen", fr: "Reconnaître le phishing", en: "Recognise phishing" }, href: { nl: "/gids/phishing-herkennen.html", fr: "/fr/guide/reconnaitre-le-phishing.html" } },
    { label: { nl: "Link controleren", fr: "Vérifier un lien", en: "Check a link" }, href: { nl: "/gids/link-controleren.html", fr: "/fr/guide/verifier-un-lien.html" } },
    { label: { nl: "Vals pakketbericht", fr: "Faux message de colis", en: "Fake parcel message" }, href: { nl: "/gids/vals-pakketbericht.html", fr: "/fr/guide/faux-message-de-colis.html" } },
    { label: { nl: "Bankmail & itsme", fr: "Mail bancaire & itsme", en: "Bank mail & itsme" }, href: { nl: "/gids/valse-bankmail-itsme.html", fr: "/fr/guide/faux-mail-bancaire-itsme.html" } },
    { label: { nl: "Geklikt op een link?", fr: "Cliqué sur un lien ?", en: "Clicked a link?" }, href: { nl: "/gids/geklikt-op-phishinglink.html", fr: "/fr/guide/clique-sur-un-lien-phishing.html" } },
    { label: { nl: "Bericht melden", fr: "Signaler un message", en: "Report a message" }, href: { nl: "/gids/verdacht-bericht-melden.html", fr: "/fr/guide/signaler-un-message-suspect.html" } },
  ];

  const cols = [
    {
      title: t("footer.product"),
      links: [
        { to: "/check", label: t("footer.links.check") },
        { to: "/pricing", label: t("footer.links.pricing") },
        { to: "/faq", label: t("footer.links.faq") },
        { to: "/check", label: t("footer.links.demo") },
      ],
    },
    {
      title: t("footer.legalCol"),
      links: [
        { to: "/privacy", label: t("footer.links.privacy") },
        { to: "/terms", label: t("footer.links.terms") },
        { to: "/cookies", label: t("footer.links.cookies") },
        { to: "/security", label: t("footer.links.security") },
      ],
    },
    {
      title: t("footer.companyCol"),
      links: [{ to: "/contact", label: t("footer.links.contact") }],
    },
  ];

  return (
    <footer className="border-t border-slate-200 bg-slate-100" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <img src="/logo.png" alt="TrustWall" className="h-9 w-9 rounded-xl object-cover" />
              <span className="text-lg font-bold text-slate-900">TrustWall</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">{t("footer.tagline")}</p>
            <a
              href="mailto:info@oasi.be"
              data-testid="footer-contact-email"
              className="mt-3 inline-block text-sm font-medium text-blue-700 transition-colors hover:text-blue-700"
            >
              info@oasi.be
            </a>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-medium text-slate-500">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" /> BE · NL
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l, i) => (
                  <li key={`${l.to}-${i}`}>
                    <Link to={l.to} className="text-sm text-slate-500 transition-colors hover:text-blue-700">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div data-testid="footer-guides">
            <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{lang === "fr" ? "Guides" : "Gidsen"}</h4>
            <ul className="mt-4 space-y-2.5">
              {guides.map((g, i) => (
                <li key={i}>
                  <a href={g.href[guideLang]} className="text-sm text-slate-500 transition-colors hover:text-blue-700">
                    {g.label[lang] || g.label.nl}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-200 pt-6">
          <p className="text-xs leading-relaxed text-slate-500">{t("footer.disclaimer")}</p>
          <p className="mt-3 text-xs text-slate-600">© {year} TrustWall by OASI PRODUCTIONS. {t("footer.rights")}</p>
          <p className="mt-1 text-xs text-slate-600" data-testid="footer-company-details">
            OASI PRODUCTIONS · Emiel van Roeystraat 12 bus 1.01, 2310 Rijkevorsel, België · KBO 0679.777.285
          </p>
        </div>
      </div>
    </footer>
  );
};
